export default "__VITE_ASSET__DjDWjTTG__"